"use client";

import React, { useEffect } from "react";
import type { DocumentNode } from "graphql";
import { embedBlockDataFragmentDoc } from "@gql/graphql";

// Define the data type for props
type EmbedBlockData = {
  embedCode?: string | null;
};

type EmbedBlockProps = {
  data: EmbedBlockData;
  inEditMode?: boolean;
};

// Extend the component type to include the static getDataFragment method
interface EmbedBlockComponent extends React.FC<EmbedBlockProps> {
  getDataFragment: () => [string, DocumentNode];
}

const EmbedBlock: EmbedBlockComponent = ({
  data,
  inEditMode = false,
}: EmbedBlockProps) => {
  const embedCode = data?.embedCode || "";

  useEffect(() => {
    const container = document.getElementById("embed-block-container");
    if (container) {
      const scripts = container.getElementsByTagName("script");
      for (let i = 0; i < scripts.length; i++) {
        const oldScript = scripts[i];
        const newScript = document.createElement("script");
        if (oldScript.src) newScript.src = oldScript.src;
        else newScript.textContent = oldScript.innerHTML;
        oldScript.parentNode?.replaceChild(newScript, oldScript);
      }
    }
  }, [embedCode]);

  return (
    <div
      id="embed-block-container"
      className="flex w-full justify-center"
      dangerouslySetInnerHTML={{ __html: embedCode }}
    />
  );
};

EmbedBlock.displayName = "Embed Block";

// Attach the data fragment to the component
EmbedBlock.getDataFragment = (): [string, DocumentNode] => [
  "EmbedBlockData",
  embedBlockDataFragmentDoc,
];

export default EmbedBlock;
